import { render, staticRenderFns } from "./SingleSpreadViewDropdownMenu.vue?vue&type=template&id=20ece4fd"
import script from "./SingleSpreadViewDropdownMenu.vue?vue&type=script&lang=js"
export * from "./SingleSpreadViewDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ece4fd')) {
      api.createRecord('20ece4fd', component.options)
    } else {
      api.reload('20ece4fd', component.options)
    }
    module.hot.accept("./SingleSpreadViewDropdownMenu.vue?vue&type=template&id=20ece4fd", function () {
      api.rerender('20ece4fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/views-page/SingleSpreadViewDropdownMenu.vue"
export default component.exports